module.exports = __webpack_public_path__ + "static/media/revisiones.07057052.png";